export default __webpack_public_path__ + "static/media/whitepaperFilipino.dec89533.pdf";